
import React from 'react';
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import MainContent from "@/components/MainContent";
import PerformanceOptimizer from '@/components/system/PerformanceOptimizer';

// Layout wrapper for public routes with navbar and footer
interface PublicLayoutProps {
  children: React.ReactNode;
  noFooter?: boolean;
}

const PublicLayout: React.FC<PublicLayoutProps> = ({ 
  children, 
  noFooter = false
}) => {
  return (
    <>
      {/* Add PerformanceOptimizer to automatically optimize images */}
      <PerformanceOptimizer />
      
      <Navbar />
      <div className="pt-16">
        <MainContent>
          {children}
        </MainContent>
      </div>
      {!noFooter && <Footer />}
    </>
  );
};

export default PublicLayout;
